import { lazy, useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';

import { PermissionsGuard } from 'admin_panel/components';
import { DEFAULT_CATEGORIES, SidebarRoutes } from 'admin_panel/router';

const PageWrapper = lazy(() => import('components/PageWrapper'));

export const PATHS = {
  ASSOCIATION: {
    path: '/commercial/associations/:associationId',
    component: lazy(() => import('./pages/Commercial/Association')),
    text: 'Association',
  },
  ASSOCIATIONS: {
    path: '/commercial/associations',
    component: lazy(() => import('./pages/Commercial/Associations')),
    text: 'Associations',
  },
  DIGITAL_PRODUCTS: {
    path: '/commercial/digital-products',
    component: lazy(() => import('./pages/Commercial/DigitalProducts')),
    text: 'Digital Products',
  },
} as const;

export const useSidebarRoutes = (): SidebarRoutes => ({
  ...DEFAULT_CATEGORIES,
  commercial: [
    {
      path: PATHS.ASSOCIATIONS.path,
      text: PATHS.ASSOCIATIONS.text,
    },
    {
      path: PATHS.DIGITAL_PRODUCTS.path,
      text: PATHS.DIGITAL_PRODUCTS.text,
    },
  ],
});

interface RouterProps {
  onSidebarUpdate?: (routes: SidebarRoutes) => void;
}

const Router = ({ onSidebarUpdate }: RouterProps) => {
  const routes = useSidebarRoutes();
  useEffect(() => {
    onSidebarUpdate?.(routes);
  }, [routes, onSidebarUpdate]);

  const AssociationPage = PATHS.ASSOCIATION.component;
  const AssociationsPage = PATHS.ASSOCIATIONS.component;
  const DigitalProductsPage = PATHS.DIGITAL_PRODUCTS.component;

  return (
    <PermissionsGuard
      permissions={['catalog_management']}
      paths={[
        PATHS.ASSOCIATION.path,
        PATHS.ASSOCIATIONS.path,
        PATHS.DIGITAL_PRODUCTS.path,
      ]}
    >
      <Switch>
        <Route exact path={PATHS.ASSOCIATION.path}>
          <PageWrapper>
            <AssociationPage />
          </PageWrapper>
        </Route>
        <Route exact path={PATHS.ASSOCIATIONS.path}>
          <PageWrapper>
            <AssociationsPage />
          </PageWrapper>
        </Route>
        <Route exact path={PATHS.DIGITAL_PRODUCTS.path}>
          <PageWrapper>
            <DigitalProductsPage />
          </PageWrapper>
        </Route>
      </Switch>
    </PermissionsGuard>
  );
};

export default Router;
